import type { UploadProps } from 'antd';
import { Tooltip, Upload } from 'antd';
import classNames from 'classnames';
import React from 'react';

import { renderAllowedMediaTooltip } from 'components/common/UploadModal/utils/renderAllowedMediaTooltip';
import useMediaRules from 'hooks/useMediaRules';

import { draggerStyle, infoStyle } from './CoreDragger/components/ui.style';
import DraggerContent from './MediasUploader/components/DraggerContent';

type FBDraggerProps = Omit<UploadProps, 'type'> & {
  allowed?: import('hooks/useMediaRules').AllowedMedias;
  icon?: string;
  displayMaxSizeMessage?: boolean;
};

const FBDragger: React.FC<FBDraggerProps> = ({ allowed, children, icon, displayMaxSizeMessage, ...rest }) => {
  const { extensions, fileTypes, config } = useMediaRules(allowed);
  const tooltip = renderAllowedMediaTooltip(extensions, config, displayMaxSizeMessage ?? false);
  const accept = React.useMemo(
    // Force `.` at the beginning of the extension name
    () => extensions?.map((extension: string) => `.${extension.replace(/^\.?/, '')}`).join(',') ?? fileTypes.join(','),
    [fileTypes, extensions]
  );

  return (
    <Upload.Dragger showUploadList={false} accept={accept} {...rest} className={classNames(rest.className, draggerStyle)}>
      {children}
      {!children && (
        <div className="p-4">
          <DraggerContent icon={icon} />
          {tooltip && (
            <Tooltip placement="left" title={tooltip}>
              <div className={classNames(infoStyle, 'fb-icon--info text-secondary position-absolute')} />
            </Tooltip>
          )}
        </div>
      )}
    </Upload.Dragger>
  );
};

export default FBDragger;
